import firebase from "firebase/app";
import "firebase/firestore";
var config = {
  apiKey: "AIzaSyCQmdXQLCCV9E58tsRbup_0CUU7zB736DY",
  authDomain: "scienceflakes-d459a.firebaseapp.com",
  databaseURL: "https://scienceflakes-d459a.firebaseio.com",
  projectId: "scienceflakes-d459a",
  storageBucket: "scienceflakes-d459a.appspot.com",
  messagingSenderId: "919549249042"
};
firebase.initializeApp(config);

const firestore = firebase.firestore();
const settings = { timestampsInSnapshots: true };
firestore.settings(settings);



// WEBPACK FOOTER //
// ./src/config/FirebaseConfig.js